<template>
  <div class="tx-steps">
    <div class="d-flex justify-center">
      <div
        v-for="(item, index) in options.filter(item => !item.hidden)"
        :key="item.step"
        :class="[
          'text-4 font-weight-medium',
          {
            'gray--text': current !== item.step,
            clickable: item.step === 1 && item.step !== current,
            'ml-16': index > 0,
          },
        ]"
        @click="setStep(item.step)"
      >
        {{ item.text }}
      </div>
    </div>
    <v-divider :class="['my-10', 'border-' + borderType]"></v-divider>
  </div>
</template>

<script>
export default {
  props: {
    options: Array,
    current: Number,
    borderType: String,
  },
  methods: {
    setStep(step) {
      if (this.current === 1) return;
      this.$emit("setStep", step);
    },
  },
};
</script>
